/**
 * Theme Requirements Aggregation for Mox
 * 
 * Extends the base prestige theme requirements with Mox specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-prestige/requirements';

/**
 * Mox component requirement overrides.
 * Add requirements for any override components here.
 */
const moxOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Mox theme.
 * Inherits from prestige theme and overrides with Mox components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...moxOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
